// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhp_jk","CommentListPlaceholder--Legacy":"ih_b bhp_rc bhp_wq"};